import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { ActivityFormInfoConfirmStyled } from "./styled";
import { Buttons } from "components";

const ActivityFormInfoConfirm = ({
  theme_standard,
  activity_code,
  activity_name_th,
  personal_first_name,
  personal_last_name,
  personal_email,
  personal_phone_number,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation(["common"]);
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <ActivityFormInfoConfirmStyled>
      <div className={customClass}>
        <div className="activity_confirm_container">
          <div className="avc_title">{t("Confirm scan", { ns: "common" })}</div>
          <div className="avc_body">
            <div className="avc_row">
              <div className="cr_left_col">{t("Activity name", { ns: "common" })}</div>
              <div className="cr_right_col">{activity_code}</div>
            </div>
            <div className="avc_row">
              <div className="cr_left_col">{t("Activity code", { ns: "common" })}</div>
              <div className="cr_right_col">{activity_name_th}</div>
            </div>
            <div className="avc_row">
              <div className="cr_left_col">{t("Customer name", { ns: "common" })}</div>
              <div className="cr_right_col">
                {personal_first_name + " " + personal_last_name}
              </div>
            </div>
            <div className="avc_row">
              <div className="cr_left_col">{t("Customer phone", { ns: "common" })}</div>
              <div className="cr_right_col">{personal_phone_number}</div>
            </div>
            <div className="avc_row">
              <div className="cr_left_col">{t("Email", { ns: "common" })}</div>
              <div className="cr_right_col">{personal_email}</div>
            </div>
          </div>
          <div className="avc_action_row">
            <div className="ca_col">
              <Buttons.BgStandard
                theme_cancel
                label={"ยกเลิก"}
                onClick={onCancel}
              />
            </div>
            <div className="ca_col">
              <Buttons.BgStandard label={"ตกลง"} onClick={onConfirm} />
            </div>
          </div>
        </div>
      </div>
    </ActivityFormInfoConfirmStyled>
  );
};

ActivityFormInfoConfirm.propTypes = {};

export default ActivityFormInfoConfirm;
